var React = require('react');

function IconDownArrowInline (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"\n      .st0 {\n        fill: #fff;\n      }\n    ")),React.createElement("polygon",{"className":"st0","points":"4.5 20.98 50 79.02 95.5 20.98 4.5 20.98","key":1})]);
}

IconDownArrowInline.defaultProps = {"id":"Layer_1","version":"1.1","viewBox":"0 0 100 100"};

module.exports = IconDownArrowInline;

IconDownArrowInline.default = IconDownArrowInline;
